<template>
  <div class="selector">
    <div class="button-wrapper">
      <span @click="optionBtnClickHandle('func')" :class="{'active': curOptionList === 'func' && optionListShow}" 
        v-if="selector.indexOf('func') >= 0">{{func}}<Icon class="arrow" type="down"/></span>
      <span @click="optionBtnClickHandle('adress')" :class="{'active': curOptionList === 'adress' && optionListShow}" 
        v-if="selector.indexOf('adress') >= 0">{{adress}}<Icon class="arrow" type="down"/></span>
      <span @click="optionBtnClickHandle('degree')" :class="{'active': curOptionList === 'degree' && optionListShow}" 
        v-if="selector.indexOf('degree') >= 0">{{degree}}<Icon class="arrow" type="down"/></span>
      <span @click="optionBtnClickHandle('salary')" :class="{'active': curOptionList === 'salary' && optionListShow}" 
        v-if="selector.indexOf('salary') >= 0">{{salary}}<Icon class="arrow" type="down"/></span>
      <span @click="$router.push('/search')" class="search" v-if="selector.indexOf('search') > 0"><Icon class="icon" type="search"/>搜索</span>
    </div>
    <div class="options" :class="optionListShow ? '' : 'hide'">
      <ul>
        <li v-for="(item, index) in optionList" :key="index"
          :class="{'select': item === optionList[$store.state.selector[place][curOptionList]]}"
          @click="optionClickHandle(index)">{{item}} <Icon class="icon" type="yes"/></li>
      </ul>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon'
import {funcList, adressList, degreeList, salaryList} from '../store'

export default {
  props: {
    selector: {
      type: Array,
      default: ['adress','degree','salary']
    },
    place: String,
  },
  data() {
    return {
      optionList: this.$store.getters.adressList,
      curOptionList: '',
      optionListShow: false
    }
  },
  computed: {
    func() {
      let tmp = funcList[this.$store.state.selector[this.place]['func']] && funcList[this.$store.state.selector[this.place]['func']].text
      // console.log(funcList, this.$store.state.selector[this.place]['func'])
      if(tmp && tmp.length > 5)
        return tmp.slice(0, 5) + '...'
      else
        return tmp || '职能筛选'
    },
    adress() {
      let tmp = adressList[this.$store.state.selector[this.place]['adress']]
      if(tmp && tmp.length > 5)
        return tmp.slice(0, 5) + '...'
      else
        return tmp || '工作地点'
    },
    degree() {
      let tmp = degreeList[this.$store.state.selector[this.place]['degree']]
      if(tmp && tmp.length > 5)
        return tmp.slice(0, 5) + '...'
      else
        return tmp || '学历筛选'
    },
    salary() {
      let tmp = salaryList[this.$store.state.selector[this.place]['salary']]
      if(tmp && tmp.length > 11)
        return tmp.slice(0, 11) + '...'
      else
        return tmp || '薪酬范围'
    },
  },
  methods: {
    
    optionListOpen(type) {
      // 打开列表
      // 获取当前选中列表
      this.optionList = this.$store.getters[(type+'List')]
      console.log(this.optionList)
      // 展示列表
      // 外部自动滚动至列表，并禁止外部滚动
      this.$eventBus.emit('homeScrollDiable')
      // 调用homesuo
      
      // 外部滚动
      this.$eventBus.emit('homeScrollToList', () => {
        setTimeout( ()=> {
          this.curOptionList = type;
          this.optionListShow = true
        }, 100)
      })
    },
    // 关闭列表 参数指定列表类型
    optionListClose() {
      // this.curOptionList = ''
      this.optionListShow = false
      // 恢复外部滚动状态
      this.$eventBus.emit('recoverHomeScroll')
    },
    // 打开选项列表
    optionBtnClickHandle(type) {
      if(this.curOptionList === type && this.optionListShow) {
        this.optionListClose();
      } else {
        this.optionListOpen(type);
      }
    },
    // 选中选项
    optionSelect(index) {
      // 提交mutation
      this.$store.commit('commitSelect', {
        place: this.place,
        option: this.curOptionList,
        value: index
      }),
      this.$store.commit('jobListGetBySelector', {place: this.place})
    },
    // 取消选项
    optionCancel() {
      this.$store.commit('cancelSelect', {
        place: this.place,
        option: this.curOptionList,
      })
      this.$store.commit('jobListGetBySelector', {place: this.place})
    },
    // 选项点击
    optionClickHandle(index) {
      // 再次点击则取消选中
      if(this.$store.state.selector[this.place][this.curOptionList] === index) {
        this.optionCancel()
      } else {
        // 选中
        this.optionSelect(index)
        // 发送筛选请求
        // 刷新数据
        // 刷新内部滚动
        // 滚动至顶部
      }
      // 收起选项框
      this.optionListClose()
    }
  },
  
  created() {
    // console.log(this.$store.getters.adressList)
  },
  components: {
    Icon
  }
}
</script>

<style lang="scss" scoped>
.selector { font-size: 0; }
.button-wrapper {
  padding-top: 16px; display: flex; height: 92px; justify-content: space-between; position: relative; z-index: 10; background: #EDF2FA;
  > span {
    padding: 0 16px; margin-left: 16px; height: 60px; line-height: 60px; flex: 1; background:#D7DFEB; border-radius:8px; position: relative; 
    font-size:24px; color:rgba(51,51,51,1); text-align: center; white-space: nowrap; transition: all .3s linear;
    &:first-child { margin-left: 0 }
    .arrow { width: 20px; margin-left: 18px; transition: all .3s linear; }
    &.active {
      background: #1A3864; color: #fff;
      .arrow { transform: rotate(180deg) };
    }
  }
  .search {
    background: #1A3864; color: #fff;
    .icon { margin-right: 18px; }
  }
}
.options {
  width: 100%; height: 100vh; background: #EDF2FA; overflow-x: hidden; overflow-y: auto; transition: all .3s linear;
  &::-webkit-scrollbar { width: 0; height: 0; }
  li {
    padding:0 4px; height: 120px; border-bottom:1px solid rgba(229,229,229, .5); font-size:34px; color:rgba(51,51,51,1); display: flex; justify-content: space-between; align-items: center;
    &.select { color: rgba(26,72,156,1); }
    &.select .icon { display: block; }
    .icon { display: none; }
  }
  &.hide { height: 0; }
}
</style>